module.exports = __webpack_public_path__ + "static/img/nbbexpo-banner.23aa55d3.png";